import React, {PureComponent, ReactNode} from 'react';
import SmartPromotionItem from 'app/components/pages/home_page/SmartPromotion/SmartPromotionItem';
import {Swiper, SwiperSlide} from 'swiper/swiper-react';
import {Autoplay, EffectFade, Pagination, Navigation} from 'swiper/modules';
import type {Swiper as SwiperType} from 'swiper';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';
import {isDesktop} from 'app/utils';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

const swiperParams = {
    allowTouchMove: true
};

interface ArticlesWithTypeProps {
    data: ArticleInterface[]
    type?: string
    nameForControls: string
}

export default class SmartPromotionList extends PureComponent<ArticlesWithTypeProps> {
    swiperInstance = React.createRef<SwiperType | null>();

    handleSwiperMouseEnter = (): void => {
        this.swiperInstance.current?.autoplay?.stop();
    };

    handleSwiperMouseLeave = (): void => {
        this.swiperInstance.current?.autoplay?.start();
    };

    setSwiperRef = (swiper: SwiperType): void => {
        (this.swiperInstance as React.MutableRefObject<SwiperType | null>).current = swiper;
    };

    render(): ReactNode {
        const {data, type, nameForControls} = this.props;
        const paginationOnDesktop = data.length > 1 ? {clickable: true, el: `.pagination-${nameForControls}`} : false;

        return <div
            className="smart-promotion-list"
            onMouseEnter={isDesktop() ? this.handleSwiperMouseEnter : null}
            onMouseLeave={isDesktop() ? this.handleSwiperMouseLeave : null}
        >
            {isDesktop()
                ? <Swiper
                    className="slider-smart-promotions"
                    {...swiperParams}
                    onSwiper={this.setSwiperRef}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false
                    }}
                    modules={[
                        Autoplay,
                        EffectFade,
                        Pagination
                    ]}
                    pagination={paginationOnDesktop}
                    effect={'fade'}
                    speed={700}
                >
                    {data.map(article => <SwiperSlide key={article.id}>
                        <SmartPromotionItem data={article} type={type}/>
                    </SwiperSlide>)}
                    <div className={`swiper-pagination-group pagination-${nameForControls}`}/>
                </Swiper>
                : <>
                    <div className="wrapper-swiper-container">
                        <Swiper
                            className="slider-container-swiper slider-smart-promotions"
                            {...swiperParams}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false
                            }}
                            modules={[
                                Autoplay,
                                EffectFade,
                                Pagination,
                                Navigation
                            ]}
                            pagination={{
                                clickable: true,
                                el: `.pagination-${nameForControls}`
                            }}
                            navigation={{
                                nextEl: `.button-${nameForControls}-next`,
                                prevEl: `.button-${nameForControls}-prev`
                            }}
                            preventClicksPropagation
                            preventInteractionOnTransition
                            effect={'fade'}
                            speed={700}
                        >
                            {data.map(article => <SwiperSlide key={article.id}>
                                <SmartPromotionItem data={article} type={type}/>
                            </SwiperSlide>)}
                        </Swiper>
                    </div>
                    <div className="slider-pagination-control">
                        <button className={`swiper-button-slider-prev button-${nameForControls}-prev`}>
                            <SpriteIcon name="#svg-swiper-arrow" className="svg-default"/>
                        </button>
                        <div className={`swiper-pagination-group pagination-${nameForControls}`}/>
                        <button className={`swiper-button-slider-next button-${nameForControls}-next`}>
                            <SpriteIcon name="#svg-swiper-arrow" className="svg-default"/>
                        </button>
                    </div>
                </>}
        </div>;
    }
}
